<template>
  <div class="flex-container">
    <div v-for="{ company, details, id } in sponsors" :key="id" >
        <router-link
          :to="{
            name: 'companyProfile',
            params: { companyId: getId(company) },
          }"
          exact
        >
          <img :class="`sponsor-img ${[0,1,2].includes(index) ? 'scale-up' : ''}`" :src="details.logo" alt />
        </router-link>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import getIDfromURL from '../../utils/getIDfromURL';

export default {
  props: {
    categoryId: {
      type: Number,
      default: '',
    },
    index: {
      type: Number,
      default: '',
    },
  },
  data() {
    return {
      sponsors: [],
    };
  },
  watch: {
    $route: {
      async handler(route) {
        if (route.params.eventId) {
          this.sponsors = await this.fetchEventSponsors(this.categoryId);
        } else if (route.params.awardId) {
          this.sponsors = await this.fetchAwardSponsors(this.categoryId);
        }
      },
    },
  },
  async mounted() {
    if (this.$route.params.eventId) {
      this.sponsors = await this.fetchEventSponsors(this.categoryId);
    }
    if (this.$route.params.awardId) {
      this.sponsors = await this.fetchAwardSponsors(this.categoryId);
    }
  },
  methods: {
    ...mapActions({
      fetchEventSponsors: 'events/fetchEventSponsors',
      fetchAwardSponsors: 'awards/fetchAwardSponsors',
    }),
    getId(url) {
      return getIDfromURL(url);
    },
  },
};
</script>

<style scoped>
.sponsor-img {
  vertical-align: middle;
  max-height: 100px;
  max-width: 125px;
  border-style: none;
  padding: 10px;
  object-fit: contain;
}
.scale-up {
  max-width: 200px;
  max-height: 200px;
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
  background-color: #ffffff;
  justify-content: center;
  border-radius: 0 0 10px 10px;
  align-items: center;
}
</style>
